import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgUndefinedGhost = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill={props.color} opacity={0.05}>
      <path d='M14.25 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M8 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0' />
    </g>
    <g fill={props.color} opacity={0.1}>
      <path d='M14.25 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M8 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0' />
    </g>
    <path
      fill={props.color}
      d='M22 12q0 10-10 10T2 12 12 2t10 10'
      opacity={0.2}
    />
    <g fill={props.color} opacity={0.3}>
      <path d='M14.25 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M8 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0' />
    </g>
    <g fill={props.color} opacity={0.4}>
      <path d='M14.25 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M8 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0' />
    </g>
    <g fill={props.color} opacity={0.5}>
      <path d='M14.25 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M8 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0' />
    </g>
    <g fill={props.color} opacity={0.6}>
      <path d='M14.25 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M8 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0' />
    </g>
    <g fill={props.color} opacity={0.7}>
      <path d='M14.25 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M8 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0' />
    </g>
    <g fill={props.color} opacity={0.8}>
      <path d='M15.5 17a1 1 0 1 0 0-2v-4a1 1 0 0 0-1.447-.894l-1 .5A1 1 0 0 0 13.5 12.5V15a1 1 0 1 0 0 2zM7.606 11.947a1 1 0 0 0 .894.553V15a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2v-4a1 1 0 0 0-1.447-.894l-1 .5a1 1 0 0 0-.447 1.341' />
    </g>
    <g fill={props.color} opacity={0.9}>
      <path d='M14.25 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M8 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0' />
    </g>
    <path
      fill={props.color}
      d='M14.25 6.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M8 7.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M3.793 3.793C5.713 1.873 8.513 1 12 1s6.287.873 8.207 2.793S23 8.513 23 12s-.872 6.287-2.793 8.207C18.287 22.127 15.487 23 12 23s-6.287-.872-8.207-2.793C1.873 18.287 1 15.487 1 12s.873-6.287 2.793-8.207m1.414 1.414C3.794 6.62 3 8.821 3 12s.794 5.38 2.207 6.793S8.821 21 12 21s5.38-.794 6.793-2.207S21 15.179 21 12s-.794-5.38-2.207-6.793S15.179 3 12 3s-5.38.794-6.793 2.207'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgUndefinedGhost)
export default ForwardRef
